import React, { useState, useRef, useEffect } from "react";
import "./DriverMultiSelect.css";

const DriverMultiSelect = ({
  label = "Field Staff",
  options = [],
  value = [],
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef();

  const values = Array.isArray(value) ? value?.filter(Boolean) : value ? [value] : [];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (option) => {
    const exists = values.find((v) => v._id === option._id);
    let updated;
    if (exists) {
      updated = values.filter((v) => v._id !== option._id);
    } else {
      updated = [...values, option];
    }
    onChange(updated);
  };

  const removeOption = (e, id) => {
    e.stopPropagation();
    onChange(values.filter((v) => v._id !== id));
  };

  const clearAll = (e) => {
    e.stopPropagation();
    onChange([]);
  };

  const filtered = options.filter(
    (o) =>
      o.driverStatus !== "Disabled" &&
      o.name.toLowerCase().includes(search?.toLowerCase())
  );

  return (
    <div className="dms-wrapper" ref={ref}>
      <fieldset
        className={`dms-fieldset ${open ? "active" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <legend className="dms-legend">{label}</legend>

        <div className="dms-input-row">
          {values.length === 0 ? (
            <span className="dms-placeholder">Select Field Staffs</span>
          ) : (
            values.map((v) => (
              <span key={v._id} className="dms-pill">
                {v.name}
                <button
                  className="dms-pill-x"
                  onClick={(e) => removeOption(e, v._id)}
                  title="Remove"
                >
                  &#x2715;
                </button>
              </span>
            ))
          )}

          {values.length > 0 && (
            <button className="dms-clear-btn" onClick={clearAll}>
              Clear all
            </button>
          )}

          <span className={`dms-chevron ${open ? "open" : ""}`}>&#9660;</span>
        </div>
      </fieldset>

      {open && (
        <div className="dms-dropdown">
          <div className="dms-search-wrap">
            <input
              type="text"
              className="dms-search"
              placeholder="Search Field Staffs.."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              autoFocus
            />
          </div>

          <div className="dms-options">
            {filtered.map((opt) => {
              const checked = values.some((v) => v._id === opt._id);
              return (
                <div
                  key={opt._id}
                  className={`dms-option ${checked ? "selected" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleOption(opt);
                  }}
                >
                  <span >
                    <input
                      type="checkbox"
                      checked={checked}
                    />
                  </span>
                  <span className="dms-driver-info">
                    <span className="dms-driver-name">{opt.name}</span>
                  </span>
                </div>
              );
            })}

            {!filtered.length && (
              <div className="dms-no-data">No drivers found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DriverMultiSelect;